// Inspired by: https://dev.to/michaelburrows/calculate-the-estimated-reading-time-of-an-article-using-javascript-2k9l
export function readingTime(text: string, wordPerMinute = 265) {
  const words = text.trim().split(/\s+/).length;

  return {
    text: Math.ceil(words / wordPerMinute) + " min read",
  };
}
